import { dateFormated } from 'common/utils/date';
import { EmployeeTagname } from 'legacy-modules/sales/component/list-tagname';
import { useRouter } from 'next/router';
import { Translate } from 'next-translate';
import React from 'react';

const GetLocale = () => {
  const { locale } = useRouter();
  return locale;
};

export const commonColumnTable = (t: Translate) => {
  const locale = GetLocale();
  return [
    {
      header: t('common:created_by'),
      accessorKey: 'createdBy.name',
      minSize: 150,
      sortName: 'created_by',
      cell: ({ getValue }) => <>{getValue() as string}</>,
    },
    {
      header: t('common:created_at'),
      accessorKey: 'createdAt',
      minSize: 150,
      sortName: 'created_at',
      cell: ({ getValue }) => dateFormated(getValue() as Date, locale),
    },
  ];
};

export const commonSaleColumnTable = (t: Translate) => [
  {
    header: t('common:operator'),
    accessorKey: 'admin',
    minSize: 150,
    cell: ({ row }) => {
      return <EmployeeTagname employee={row.original.admin} />;
    },
  },
  {
    header: t('common:sales'),
    accessorKey: 'operator',
    minSize: 150,
    cell: ({ row }) => {
      return <EmployeeTagname employee={row.original.operator} />;
    },
  },
  {
    header: t('common:lead'),
    accessorKey: 'sales',
    minSize: 150,
    cell: ({ row }) => {
      return <EmployeeTagname employee={row.original.salesman} />;
    },
  },
];
